import { ButtonTertiary } from "components/Atoms/Button";
import { DocumentV1FormState } from "documentV1/detail/documentFormState";
import { AxiosResponse } from "axios";
import React from "react";
import { captureException } from "@sentry/react";

interface Props {
  canModify: boolean;
  convertTo: server.dto.DocumentLifeCycles;
  onConverted: () => Promise<any>
  updateDocument: (update: Partial<DocumentV1FormState>) => Promise<AxiosResponse<server.dto.ApiResponse, any>>
}

export const SendDocumentButton = (props: Props) => {
  const [hasPressedUpdate, setHasPressedUpdate] = React.useState(false);
  const [error, setError] = React.useState<string>(null);

  const sendDocument = async () => {
    setHasPressedUpdate(true);
    try {
      const res = await props.updateDocument({
        lifeCycle: {
          value: props.convertTo,
          text: ""
        }
      });

      if (res.data.hasErrors) {
        setError(res.data.errors[0].message);
        setHasPressedUpdate(false);
        return;
      }
    } catch (e) {
      captureException(e);
      console.error(e);
      setError(RESX.GeneralLabels.SomethingUnexpectedHappened);
      setHasPressedUpdate(false);
      return;
    }

    props.onConverted();
  }

  if (props.canModify) {
    return <div className="flex-column gap">
      <div>
        <ButtonTertiary
          onClick={sendDocument}
          label={RESX.Invoice.ConvertToInvoice}
          loading={hasPressedUpdate}
          disabled={hasPressedUpdate}
        />
      </div>
      {error && <div className="ui message red">
        {error}
      </div>}
    </div>
  }

  return <div>{RESX.InvoiceDocument.ProForma}</div>;
}